module.exports = __webpack_public_path__ + "media/images/award-badges-my-30bd9a493b2bdf7d264cfca60c37d436.svg";